(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/transaction-input.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/transaction-input.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const Button = svs.ui.ReactButton;
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem;
const Form = svs.ui.reactForm.Form;
const AmountInput = svs.ui.reactFormInputs.AmountInput;
const submitWithdrawFromTeam = svs.arena.pages.teams.helpers.submitWithdrawFromTeam;
const submitDeposit = svs.arena.shared.deposit.doDeposit.submitDeposit;
const setTeamBalance = svs.arena.store.teams.actions.setTeamBalance;
const returnStatus = svs.arena.constants.returnStatus;
const errorMessageMaxDeposit = 'Observera att högsta insättningsbelopp är 25 000 kr.';
const errorMessageMaxWithdraw = 'Du kan högst ta ut ditt saldo i laget.';
const TransactionInput = _ref => {
  let teamId = _ref.teamId,
    teamName = _ref.teamName,
    myTeamAmount = _ref.myTeamAmount,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? () => {} : _ref$onSuccess;
  const dispatch = ReactRedux.useDispatch();
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDeposit = _useState2[0],
    setIsDeposit = _useState2[1];
  const _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    amount = _React$useState2[0],
    setAmount = _React$useState2[1];
  const _React$useState3 = React.useState(25000),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    maxAmount = _React$useState4[0],
    setMaxAmount = _React$useState4[1];
  const _React$useState5 = React.useState(errorMessageMaxDeposit),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    errorMessageMax = _React$useState6[0],
    setErrorMessageMax = _React$useState6[1];
  const startDeposit = async amountIn => {
    svs.arena.logger.debug('Do deposit tranfer...', amountIn);
    const _await$submitDeposit = await submitDeposit(amountIn, teamId),
      status = _await$submitDeposit.status,
      error = _await$submitDeposit.error,
      memberBalance = _await$submitDeposit.memberBalance,
      syndicateBalance = _await$submitDeposit.syndicateBalance,
      playableAmount = _await$submitDeposit.playableAmount;
    if (status === returnStatus.SUCCESS) {
      svs.arena.logger.debug('Do deposit transfer success! status, syndicateBalance, playableAmount: ', status, syndicateBalance, playableAmount);
      dispatch(setTeamBalance({
        teamId,
        memberBalance,
        syndicateBalance,
        playableAmount
      }));
      onSuccess(memberBalance);
    } else if (status === returnStatus.ERROR) {
      svs.arena.logger.warn('Do deposit transfer NOT success! status, error: ', status, error);
    }
  };
  const startWithdraw = async amountIn => {
    svs.arena.logger.debug('Do withdrawal tranfer...', amountIn);
    const _await$submitWithdraw = await submitWithdrawFromTeam({
        amount: amountIn,
        teamId,
        teamName
      }),
      status = _await$submitWithdraw.status,
      error = _await$submitWithdraw.error,
      memberBalance = _await$submitWithdraw.memberBalance,
      syndicateBalance = _await$submitWithdraw.syndicateBalance,
      playableAmount = _await$submitWithdraw.playableAmount;
    if (status === returnStatus.SUCCESS) {
      svs.arena.logger.debug('Do deposit transfer success! status, syndicateBalance, playableAmount: ', status, syndicateBalance, playableAmount);
      dispatch(setTeamBalance({
        teamId,
        memberBalance,
        syndicateBalance,
        playableAmount
      }));
    } else if (status !== returnStatus.CANCEL) {
      svs.arena.logger.warn('Do deposit transfer NOT success! status, error: ', status, error);
    }
  };
  useEffect(() => {
    svs.arena.logger.debug('TransactionInput, useEffect, isDeposit, myTeamAmount: ', isDeposit, myTeamAmount);
    setAmount('');
    setMaxAmount(isDeposit ? 25000 : parseInt(myTeamAmount, 10) || 0);
    setErrorMessageMax(isDeposit ? errorMessageMaxDeposit : errorMessageMaxWithdraw);
  }, [isDeposit, myTeamAmount]);
  const onSubmitHandler = async (e, formData, isValid) => {
    svs.arena.logger.debug('onSubmitHandler', isValid, formData);
    e.preventDefault();
    if (isValid && parseInt(amount, 10) > 0) {
      if (isDeposit) {
        startDeposit(amount);
      } else {
        startWithdraw(amount);
      }
    }
  };
  const onValidateHandler = (name, isValid, errorMessage) => {
    svs.arena.logger.debug('onValidateHandler:', name, isValid, errorMessage);
  };
  return React.createElement(React.Fragment, null, React.createElement("div", null, React.createElement("h4", {
    className: "h4 margin-top-1 margin-bottom-0"
  }, React.createElement("span", {
    className: "f-medium"
  }, " \xD6verf\xF6ring "))), React.createElement("div", {
    className: "align-center margin-top override"
  }, React.createElement(ItemsMenu, {
    branding: "arena",
    centered: true
    ,
    useScrollFaders: true,
    useScrollHelpers: svs.core.detect.formfactor.desktop()
  }, React.createElement(LinkItem, {
    Component: "a",
    gutter: 1,
    label: "Till lagkonto",
    onClick: () => setIsDeposit(true),
    selected: isDeposit
  }), React.createElement(LinkItem, {
    Component: "a",
    gutter: 1,
    label: "Fr\xE5n lagkonto ",
    onClick: () => setIsDeposit(false),
    selected: !isDeposit
  })), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement(Form, {
    className: "js-syndicate-deposit-form align-left form-margin-override",
    isVertical: true,
    onSubmit: onSubmitHandler,
    onValidate: onValidateHandler
  }, React.createElement(AmountInput, {
    errorMessageDefault: "Felaktigt angivet belopp. Ange belopp i hela kronor.",
    errorMessageMax: errorMessageMax,
    label: "Ange belopp",
    max: maxAmount,
    min: 1,
    name: "amountInput",
    onChange: e => {
      setAmount(e.target.value);
    },
    type: "number",
    value: amount
  }), React.createElement(Button, {
    block: true,
    className: "margin-xs-top-1 js-submit-button",
    size: 200,
    transparent: true,
    type: "submit"
  }, isDeposit ? 'För över till lagkonto' : 'För över från lagkonto')))));
};
svs.arena.pages.teams.components.TransactionInput = TransactionInput;

 })(window);